import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetUserPayrollMonthsByFilterRequestInput,
  PayrollGetUserPayrollMonthsByFilterGraphQLRequest,
  PayrollGetUserPayrollMonthsByFilterResponse,
} from '../types';

const payrollGetUserPayrollMonthsByFilterQuery = gql`
  query PayrollGetUserPayrollMonthsByFilter($input: GetUserPayrollMonthsByFilterRequestInput!) {
    payrollGetUserPayrollMonthsByFilter(input: $input) {
      code
      success
      message
      data {
        message
        userPayrollMonths {
          userId
          payrollMonths
          statusCode
          errorMessage
        }
      }
    }
  }
`;

export const getUserPayrollMonthsByFilter = (input: GetUserPayrollMonthsByFilterRequestInput) => {
  return graphQLApi<
    PayrollGetUserPayrollMonthsByFilterResponse,
    PayrollGetUserPayrollMonthsByFilterGraphQLRequest
  >({
    query: payrollGetUserPayrollMonthsByFilterQuery,
    queryVariables: { input },
  });
};

